export const getHomeRouteForLoggedInUser = (userData: any) => {
  if (userData && userData.role === "tik_tok_manager")
    return { name: "tiktok-brands" };
  if (userData && userData.role === "tik_tok_uploader")
    return { name: "tiktok-report-uploader" };
  if (userData) return { name: "products" };
  return { name: "login" };
};
